import messages_fr from "./fr.json";

export const messages: any = {
    'fr': messages_fr,
};

export const language = navigator.language.split(/[-_]/)[0];